import React from 'react'
// import { useState, useEffect } from "react";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import "react-data-table-component-extensions/dist/index.css";
import DataService from ".././../services/tutorial.service";
import "react-confirm-alert/src/react-confirm-alert.css";
import * as AiIcons from "react-icons/ai";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import Navigationtitle from "../include/Navigationtitle";
import { Image, Shimmer } from "react-shimmer";
import LoadingOverlay from "react-loading-overlay-ts";
import { actlistData, joinAuction } from "../../actions/index";
import { useForm } from "react-hook-form";
import { BASE_PATH } from ".././../constants/Global";
import { Link, useHistory } from "react-router-dom";
import dateFormat from "dateformat";
import { auctiondefaultLogo } from "../../constants/Images";
import NotFound from "../include/NotFound";
import BounceLoader from "react-spinners/ClipLoader";
import { maxStringNew } from "../../Helpers/Helpers";
import { playerdefaultLogo } from "../../constants/Images";
import { useMediaQuery } from "react-responsive";
import ImageCropper from "../cropper/ImageCropper";
import { bat } from "../../constants/Images";
import { ball } from "../../constants/Images";
import { wkeeper, qr1 } from "../../constants/Images";
import ImageCropper1 from "../cropper/ImageCropper";
import ImageCropper2 from '../utils/Demo';
export default function JoinauctionCode3() {
  const [isDisabled, setDisabled] = useState(false);
  // const getpageData = useSelector((state) => state.setJoinAuction);
  const loginuser = useSelector((state) => state.setUserlog);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue
  } = useForm();
  const [othersp3, setOthersp3] = useState(false);
  const [sp3, setsp3] = useState("");

  const [batting, setBatting] = useState("none");
  const [getpageData, setgetpageData] = useState('');
  const [otherBatting, setOtherBatting] = useState(0);
  const [otherBowling, setOtherBowling] = useState(0);
  const [bowling, setBowling] = useState(0);
  const [cid, setCid] = useState(loginuser["cid"]);
  const [catData, setcatData] = useState([]);
  const [isjoinanother, setisjoinanother] = useState(false)
  const [catid, setcatid] = useState("");
  const [isbat, setisbat] = useState(false);
  const [isbol, setisbol] = useState(false);
  const [iswkeep, setiswkeep] = useState(false);
  const [croppedImage, setCroppedImage] = useState("");
  const [isregon, setisregon] = useState(false);
  const [defimg, setdefimg] = useState(playerdefaultLogo);
  const [defimg2, setdefimg2] = useState("");
  const [auctype, setauctype] = useState(getpageData.response?.data?.detail && getpageData?.response?.data.detail.acttype
    ? getpageData.response.data.detail.acttype
    : "0")

  const [sp1opt, setsp1opt] = useState(['All Rounder', 'Batting All Rounder', 'Bowling All Rounder', 'All Rounder Wicketkeeper', 'Batsman', 'Bowler', 'Wicket Keeper', 'Batter', 'Other']);

  const [sp2opt, setsp2opt] = useState(['Right Hand', 'Left Hand', 'Right Hand Batsman', 'Left Hand Batsman', 'Right Hand Opener', 'Left Hand Opener', 'Right Hand Middle Order', 'Left Hand Middle Order']);
  const [sp3opt, setsp3opt] = useState(['Right Arm Fast', 'Right Arm Medium', 'Left Arm Fast', 'Left Arm Medium', 'Off-Break', 'Leg-Break', 'Left Arm Orthodox', 'Left Arm Chanaman']);

  const [joinauctionAid, setjoinauctionAid] = useState(
    getpageData.response?.data?.detail && getpageData?.response?.data.detail.aid
      ? getpageData.response.data.detail.aid
      : null
  );
  const [auctionCode, setauctionCode] = useState(
    getpageData?.response?.data.detail && getpageData?.values.acode
      ? getpageData.values.acode
      : null
  );
  const [data, setData] = useState('');
  const [path, setpath] = useState('');


  const [playingStyle, setPlayingStyle] = useState("");

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
  const isPortrait = useMediaQuery({ query: "(orientation: portrait)" });

  const history = useHistory({ forceRefresh: true });
  var savenew = 0;
  let logo_pic = "";

  const [isSubmitting, setIsSubmitting] = useState(false);

  const fetchallData = (values) => {
    //  console.log('fetching api')

    setDisabled(true);
    const id = toast.loading("Please wait...");
    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
    });

    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: JSON.stringify([{ cid: 0, token: 0 }]),
      },
    };
    //  console.log("")
    DataService.JoinauctionCode(values, hdr)
      .then((res) => {
        let response = res.data;
         console.log(values)
         console.log('response is.....')
         console.log(response)
        if (response.data.detail.reg_player_on == '1') {
          setisregon(true)
        }
        setauctype(response.data.detail.acttype)


        toast.dismiss(toastContainerId);
        setgetpageData({ response, values })

        // dispatch(joinAuction({ response, values }));

        // if (response.success == true) {
        // if (response.data.detail.reg_player_on === "1") {
        //   //  console.log("code submit")
        //   //  console.log(response.data)
        //   localStorage.setItem("auction_id", response.data.detail.aid);

        //   toast.success("Now you can Join", {
        //     theme: "dark",
        //     position: "bottom-center",
        //   });
        //   history.push(BASE_PATH + "join-auction");
        // }
        // else {
        //   setjoindata(response.data.detail)
        // }


        // } else {
        //   toast.error(response.msg, { theme: "colored" });
        // }

        // setDisabled(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        toast.dismiss(toastContainerId);
        toast.error("Not valid Serverrr Error", { theme: "colored" });
        setDisabled(false);
      });
    // localStorage.removeItem('acode')
  };

  const fetchcatData = async (aid) => {
    // setActive(true);

    var hdr = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        "Authorization": JSON.stringify([{ 'cid': 0, 'token': 0 }])
      }
    }

    await DataService.listCategory({ 'aid': aid }, hdr)

      .then(res => {
        //  console.log('categories response')
        //  console.log(res)
        let response = res.data;

        if (response.success == true) {

          let responsedata = response.data;
          //  console.log(responsedata);
          setcatData(responsedata.list);
        }
        // setActive(false);

      }).catch(() => {
        //  console.log('Not valid')
        // setActive(false);
      })
  };

  useEffect(() => {
    localStorage.setItem('crp_typ',0)
    var values = {
      'acode': localStorage.getItem('acode')
    }
    //  console.log('initial state')
    fetchallData(values)


  }, [])
  useEffect(() => {
     console.log('get page data ')
     console.log(getpageData)
    if (getpageData != '') {
      localStorage.setItem('auction_id', getpageData.response.data.detail.aid)
      console.log('getpageData.response.data.detail')
      console.log(getpageData.response.data)
      console.log(getpageData.response.data)
      setData(getpageData.response.data.detail)
      setpath(getpageData.response.data.path)
      // fetchcatData(getpageData.response.data.detail.aid)
      setcatData(getpageData.response.data.detail.catlist);


    }


  }, [getpageData])
  useEffect(() => {
    if (loginuser) {
      if (loginuser.photo) {
        setdefimg(loginuser.photo)
        setdefimg2(loginuser.photo.split('/')[4])
      }
      setValue('pname', loginuser.cperson)
      setValue('mobno', loginuser.mobno)
      setValue('fname', loginuser.fname)
    }
  }, [loginuser])

  const onSubmit = async (values) => {
    if (isSubmitting) return;
    
    try {
      setIsSubmitting(true);
      setDisabled(true);

      if (croppedImage == "" && defimg == playerdefaultLogo) {
        alert('Please add your profile picture !!')
        setIsSubmitting(false);
        setDisabled(false);
        return;
      }

      if (document.getElementById("logo_pic") != null) {
        logo_pic = document.getElementById("logo_pic").value;
      }
      var hdr = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: JSON.stringify([{ cid: 0, token: 0, aid: localStorage.getItem('auction_id') }]),
        },
      };
      var icon = ''
      if (isbat == true) {
        if (icon == '') {
          icon += 'bat.png'
        }
        else {
          icon += ',bat.png'
        }

      }
      if (isbol == true) {
        if (icon == '') {
          icon += "ball.png"
        }
        else {
          icon += ",ball.png"
        }

      }
      if (iswkeep == true) {
        if (icon == '') {
          icon += "gloves.png"
        }
        else {
          icon += ",gloves.png"
        }

      }
      if (croppedImage == "") {

        values["a_photo"] = defimg2;
      }
      else {
        values["logo_pic"] = croppedImage;

      }

      const id = toast.loading("Please wait...");
      let toastContainerId = toast.update(id, {
        render: "please wait...",
        theme: "dark",
      });
      values["icons"] = icon;
      if (auctype == 0) {
        values["spcf3"] = sp3;
      }
      console.log('pl submitted values...........')
      console.log(values)
      await DataService.joinPlayer(values, hdr)
        .then((res) => {
          let response = res.data;
          toast.dismiss(toastContainerId);

          if (response.success == true) {
            let submitdata = [response.data.new];

            toast.success('Successfully Joined', {
              theme: "dark",
              position: "bottom-center",
            });
            localStorage.setItem('cjoined', data.auctionname)
            savenew ? reset() : history.push(`${BASE_PATH}join-auction-success`);
          } else {
            toast.error(response.msg, { theme: "colored" });
          }
        })
        .catch(() => {
          toast.dismiss(toastContainerId);
          toast.error("Not valid Server Error", { theme: "colored" });
        })
        .finally(() => {
          setIsSubmitting(false);
          setDisabled(false);
        });

    } catch (error) {
      setIsSubmitting(false);
      setDisabled(false);
      toast.error("An error occurred", { theme: "colored" });
    }
  };


  var batstyle = {
    backgroundColor: 'white'
  }
  var bolstyle = {
    backgroundColor: 'white'
  }
  var wkeepstyle = {
    backgroundColor: 'white'
  }
  if (isbat == true) {
    batstyle = {
      backgroundColor: 'black',
      color: 'white',
      border: '3px solid blue'
    }
  }
  if (isbol == true) {
    bolstyle = {
      backgroundColor: 'black',
      color: 'white',
      border: '3px solid blue'
    }
  }
  if (iswkeep == true) {
    wkeepstyle = {
      backgroundColor: 'black',
      color: 'white',
      border: '3px solid blue'
    }
  }
  return (
    <div>
      {/* <Navigationtitle data={match} /> */}

      {getpageData ? (
        <div
          id="top-categories"
          className="top-cat-area default-padding bottom-less"
        >
          <div className="container-fluid">
            <div className="row">
              <div id="contact-us" className="reg-area reg-area2">
                <div className="container-fluid">
                  <div
                    className="row joinheader"
                    style={{
                      backgroundColor: "rgb(248 248 251)",
                      margin: "20px 0px",
                      padding: "25px 6px",
                      borderRadius: "2px",
                    }}
                  >
                    <div className="item vertical">
                      <div className="info join-auction-form">
                        <div className="col-md-6 join-auction-info">
                          {data ? (
                            <div className="row onlyflex">
                              <div className="col-md-2 join-auction-padding">
                                <Image
                                  fallback={
                                    <Shimmer width={50} height={50} />
                                  }
                                  src={
                                    data && data.alogo != null
                                      ?
                                      path + data.alogo
                                      // getpageData.response.data.detail.path
                                      // .getpageData.response.data.detail
                                      // .alogo
                                      : auctiondefaultLogo
                                  }
                                ></Image>
                              </div>

                              <div className="col-md-10">
                                <h5>{data.auctionname} </h5>
                                <p>Auction on : {data.dt}</p>
                                {data.info && <p style={{ whiteSpace: "pre-line",lineHeight: '17px' }}>{data.info}</p>}
                                {(localStorage.getItem('auction_id') == 38332) && <p>Tournament dates : Feb 2nd 2025</p>}
                                {(localStorage.getItem('auction_id') == 38332) && <p>Ground : Skyline University, Sharjah</p>}
                                {(localStorage.getItem('auction_id') == 38332) && <p>Helpline No. : +97 1554880193, +97 1527741732, +97 1555848783</p>}

                                {(localStorage.getItem('auction_id') == 39141) && <p style={{lineHeight: '17px'}}> <b> Tournament Date</b> : 11-02-2025 , Tuesday Morning</p>}
                                {(localStorage.getItem('auction_id') == 39141) && <p style={{lineHeight: '17px'}}> <b> Important note</b> : Please make sure that you will be available for the tournament once you have registered. The selected players who are not playing in the tournament without valid reason will be banned from upcoming auction tournaments.</p>}
                              </div>
                            </div>
                          ) : (
                            <></>
                          )}
                        </div>
                        {/* {isjoinanother && <div className="col-md-6 join-auction-info-form">
                          <div className="row">
                            <form
                              onSubmit={handleSubmitCode(auctionCodeSubmit)}
                              action=""
                              autoComplete="off"
                              encType="multipart/form-data"
                            >
                              <div className="col-md-4">
                                <div className="form-group">
                                  <input
                                    className="form-control"
                                    type="text"
                                    maxLength={9}
                                    minLength={8}
                                    placeholder="Enter A-Code"
                                    {...registerCode("acode", {
                                      required: true,
                                      required: "required field.",
                                    })}
                                  />
                                  {errorsCode.acode && (
                                    <p className="text-error">
                                      {errorsCode.acode.message}
                                    </p>
                                  )}
                                </div>
                              </div>

                              <div className="col-md-8 join-auction-padding">
                                <div className="form-group">
                                  <button className="button" type="submit">
                                    {" "}
                                    SUBMIT
                                  </button>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>} */}
                        {/* {!isjoinanother && <button onClick={() => setisjoinanother(!isjoinanother)} className="joinanotherbtn">Join Another</button>} */}
                      </div>
                    </div>
                    {!isregon && <div style={{ fontSize: '2rem', fontWeight: 'bold' }}>Registration Closed !</div>}
                  </div>
                  {isregon &&
                    <div className="row">
                      <div className="reg-items">
                        <div className="col-md-5  reg-form">
                          <form
                            onSubmit={handleSubmit(onSubmit)}
                            action=""
                            autoComplete="off"
                            encType="multipart/form-data"
                          >
                            <div className="row">
                              <div className="col-md-12">
                                <input
                                  {...register("acode")}
                                  type="hidden"
                                  defaultValue={localStorage.getItem('acode')}
                                />
                                <div className="row">
                                  <div className="col-md-6">
                                    <div className="form-group text-box-margin">
                                      <div className="col-md-4 margin-top-14px">
                                        <label htmlFor="crop-pic">
                                          {" "}
                                          Profile Pic*{/*logo*/}{" "}
                                        </label>
                                      </div>
                                      <div className="col-md-8 margin-top-14px">
                                        {/* <Demo /> */}
                                        {localStorage.getItem('crp_typ') == 0 ?
                                          <ImageCropper2
                                            croppedImage={croppedImage}
                                            defaultImage={defimg}
                                            setCroppedImage={setCroppedImage}
                                          /> :
                                          <ImageCropper1
                                            croppedImage={croppedImage}
                                            defaultimage={defimg}
                                            setCroppedImage={setCroppedImage}
                                          />

                                        }
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-md-6">

                                    {/* {!loginuser && */}
                                    <div className="row padd15">
                                      <div className="col-md-4">
                                        <div className="form-group text-box-margin nobottommar">
                                          {localStorage.getItem('auction_id') == 38332 ?
                                            <label>Player's Name</label> : <label>Name</label>}

                                        </div>
                                      </div>
                                      <div className="col-md-8">
                                        <div className="form-group text-box-margin">

                                          <input
                                            className="form-control"
                                            type="text"
                                            id="pname"
                                            {...register("pname", {
                                              required: "This is required"
                                            })}
                                          />
                                          {errors.pname && (
                                            <p className="text-error">
                                              {errors.pname.message}
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                    </div>

                                    <div className="row padd15">
                                      <div className="col-md-4">
                                        <div className="form-group text-box-margin nobottommar">
                                          {/* <label>{data.show.mobile.label !== "" ? data.show.mobile.label.charAt(0).toUpperCase() + data.show.mobile.label.slice(1) : "Mobile No."}{data.show.mobile.req == '1' && '*'}</label> */}
                                          {localStorage.getItem('auction_id') == 38332 ?
                                            <label htmlFor="">WhatsApp Number*</label> : <label htmlFor="">Mobile No.</label>
                                          }
                                        </div>
                                      </div>
                                      <div className="col-md-8">
                                        <div className="form-group text-box-margin">

                                          <input
                                            className="form-control"
                                            type="number"
                                            id="mobno"
                                            {...register("mobno", {
                                              required: "This is required"
                                            })}
                                          />
                                          {errors.mobno && (
                                            <p className="text-error">
                                              {errors.mobno.message}
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                    </div>

                                    {/* } */}
                                    {data != '' && data.show.age.show == 1 &&
                                      <div className="row padd15">
                                        <div className="col-md-4">
                                          <div className="form-group text-box-margin nobottommar">
                                            <label> {data?.show.age.label !== "" ? data?.show.age.label.charAt(0).toUpperCase() + data?.show.age.label.slice(1) : "Age"}{data?.show.age.req == '1' && '*'}</label>

                                          </div>
                                        </div>
                                        <div className="col-md-8">
                                          <div className="form-group text-box-margin">

                                            <input
                                              className="form-control"
                                              type="number"
                                              id="age"
                                              {...register("age", {
                                                required: data?.show.age.req == 1 ? "This is required" : false
                                              })}
                                            />
                                            {errors.age && (
                                              <p className="text-error">
                                                {errors.age.message}
                                              </p>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    }
                                    {data != '' && data.show.fname.show == 1 &&

                                      <div className="row padd15">
                                        <div className="col-md-4">
                                          <div className="form-group text-box-margin nobottommar">
                                            <label>{data.show.fname.label !== "" ? data.show.fname.label.charAt(0).toUpperCase() + data.show.fname.label.slice(1) : "Father's name"}{data.show.fname.req == '1' && '*'}</label>

                                          </div>
                                        </div>
                                        <div className="col-md-8">
                                          <div className="form-group text-box-margin">

                                            <input
                                              className="form-control"
                                              type="text"
                                              id="fname"
                                              placeholder={data.show.fname.pholder || "Father's Name"}

                                              {...register("fname", {
                                                required: data.show.fname.req == 1 ? "This is required" : false

                                              })}

                                            />
                                            {errors.fname && (
                                              <p className="text-error">
                                                {errors.fname.message}
                                              </p>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    }

                                  </div>

                                </div>








                                {data != '' && data.show.tname.show == 1 &&
                                  <div className="col-md-6">
                                    <div className="form-group text-box-margin">
                                      <label htmlFor="tshirt">
                                        {" "}
                                        {data.show.tname.label !== "" ? data.show.tname.label.charAt(0).toUpperCase() + data.show.tname.label.slice(1) : "Jersey Name"}{data.show.tname.req == '1' && '*'}
                                      </label>
                                      <input
                                        placeholder={data.show.tname.pholder || "Jersey Name"}
                                        className="form-control"
                                        type="text"
                                        {...register("jrnm", {
                                          required: data.show.tname.req == 1 ? "This is required" : false

                                        })}
                                      />
                                      {errors.jrnm && (
                                        <p className="text-error">
                                          {errors.jrnm.message}
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                }
                                {data != '' && data.show.tno.show == 1 &&
                                  <div className="col-md-6">
                                    <div className="form-group text-box-margin">
                                      <label htmlFor="tshirt">
                                        {" "}
                                        {data.show.tno.label !== "" ? data.show.tno.label.charAt(0).toUpperCase() + data.show.tno.label.slice(1) : "Jersey Number"}{data.show.tno.req == '1' && '*'}
                                      </label>
                                      <input
                                        placeholder={data.show.tno.pholder || "Jersey Number"}
                                        className="form-control"
                                        type="number"
                                        {...register("jrno", {
                                          required: data.show.tno.req == 1 ? "This is required" : false

                                        })}
                                      />
                                      {errors.jrno && (
                                        <p className="text-error">
                                          {errors.jrno.message}
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                }
                                {data != '' && data.show.tshirt.show == 1 &&

                                  <div className="col-md-6">
                                    <div className="form-group text-box-margin">
                                      <label htmlFor="tshirt">
                                        {" "}
                                        {data.show.tshirt.label !== "" ? data.show.tshirt.label.charAt(0).toUpperCase() + data.show.tshirt.label.slice(1) : "T-Shirt Size"}{data.show.tshirt.req == '1' && '*'}
                                      </label>
                                      <input
                                        className="form-control"
                                        type="text"
                                        placeholder={data.show.tshirt.pholder || ((localStorage.getItem('aid') == 37866 ? '28/30/32/34/36/38/40' : "S/M/L/XL/XXL/XXXL"))}
                                        id="tshirt"
                                        {...register("tshirt", {
                                          required: data.show.tshirt.req == 1 ? "This is required" : false

                                        })}

                                      />

                                      {errors.tshirt && (
                                        <p className="text-error">
                                          {errors.tshirt.message}
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                }
                                {data != '' && data.show.trouser.show == 1 &&

                                  <div className="col-md-6">
                                    <div className="form-group text-box-margin">
                                      <label htmlFor="trouser"> {data.show.trouser.label !== "" ? data.show.trouser.label.charAt(0).toUpperCase() + data.show.trouser.label.slice(1) : "Trouser"}{data.show.trouser.req == '1' && '*'}</label>
                                      <input
                                        className="form-control"
                                        id="trouser"
                                        placeholder={data.show.trouser.pholder || "S/M/L/XL/XXL/XXXL"}
                                        type="text"
                                        {...register("trouser", {
                                          required: data.show.trouser.req == 1 ? "This is required" : false

                                        })}
                                      >

                                      </input>
                                      {errors.trouser && (
                                        <p className="text-error">
                                          {errors.trouser.message}
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                }
                                {data != '' && data.extra.length > 0 && data.extra.map((item, index) => {
                                  if (item.o) {
                                    var dynamicoptions = item.o.split(',')
                                  }
                                  console.log('item is.........')
                                  console.log(item)
                                  if(item.s==0) return
                                  return (
                                    <div className="col-md-6">
                                      <div className="form-group text-box-margin">
                                        <label htmlFor="tshirt">
                                          {" "}
                                          {item.l}{item.r == '1' && '*'}
                                        </label>
                                        {item.t == '0' ?
                                          <input
                                            placeholder={item.pholder || item.label}
                                            className="form-control"
                                            type="text"
                                            {...register("extra_" + index, {
                                              required: item.r == 1 ? "This is required" : false
                                            })}
                                          />
                                          :
                                          item.t == '1' ?
                                            <input
                                              placeholder={item.label}
                                              className="form-control"
                                              type="number"
                                              {...register("extra_" + index, {
                                                required: item.r == 1 ? "This is required" : false
                                              })}
                                            /> :

                                            <select
                                              className="form-control"
                                              id={item.label}
                                              type="text"
                                              {...register("extra_" + index, {
                                                required: item.r == 1 ? "This is required" : false

                                              })}
                                            >
                                              <option value="">--select--</option>
                                              {dynamicoptions?.map((el, ind) => {

                                                return (

                                                  <option value={el}>{el}</option>
                                                )
                                              })}

                                            </select>

                                        }
                                        {errors.trouser && (
                                          <p className="text-error">
                                            {errors.trouser.message}
                                          </p>
                                        )}
                                      </div>
                                    </div>
                                  )
                                })
                                }
                                {(data != '' && data.show.cat.show == 1 && catData.length > 0) &&

                                  <div className="col-xs-12 col-sm-12 col-md-4 margin-top-14px-isowner">
                                    <label htmlFor="spcf1">
                                      {" "}
                                      {data.show.cat.label !== "" ? data.show.cat.label.charAt(0).toUpperCase() + data.show.cat.label.slice(1) : "Category"}   {data.show.cat.req == '1' && '*'}                                           </label>
                                    <select
                                      className="form-control"
                                      type="text"
                                      {...register("catid", {
                                        required: data.show.cat.req == 1 ? "This is required" : false

                                      })}
                                      value={
                                        catid
                                      }
                                      onChange={(e) => {
                                        setcatid(e.target.value);
                                      }}
                                    >
                                      <option value="" selected>
                                        Select {data.show.cat.label !== "" ? data.show.cat.label.charAt(0).toUpperCase() + data.show.cat.label.slice(1) : "Category"}
                                      </option>
                                      {catData?.map(
                                        (ct) => (
                                          <option
                                            value={ct.cid}
                                            key={ct.cid}
                                          >
                                            {ct.cname}
                                          </option>
                                        )
                                      )}
                                    </select>
                                    {errors.catid && (
                                      <p className="text-error">
                                        {errors.catid.message}
                                      </p>
                                    )}
                                  </div>
                                }
                                {(data != '' && data.show.icon.show == 1 && auctype == "0") &&
                                  <div className="col-md-12 martop">
                                    <div className="row">
                                      <div className="col-md-2 margin-top-14px">
                                        <label htmlFor="">
                                          {" "}
                                          {data.show.icon.label !== "" ? data.show.icon.label.charAt(0).toUpperCase() + data.show.icon.label.slice(1) : "Playing style"}{data.show.icon.req == '1' && '*'}
                                        </label>
                                      </div>
                                      <div className="col-md-8 ">
                                        <div
                                          className={`roleclass form-group text-box-margin ${isTabletOrMobile || isPortrait
                                            ? "row"
                                            : null
                                            }`}
                                        >

                                          <div className="" >
                                            <img onClick={() => setisbat(!isbat)} src={bat} alt="" style={batstyle} />
                                          </div>
                                          <div className="" >
                                            <img onClick={() => setisbol(!isbol)} src={ball} alt="" style={bolstyle} />
                                          </div>
                                          <div className="">
                                            <img onClick={() => setiswkeep(!iswkeep)} src={wkeeper} alt="" style={wkeepstyle} />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                }


                                <div className="col-md-12 margin-top-14px">
                                  <div className="row">
                                    <div className="col-md-6">
                                      {data != '' && data.show.sp1.show == 1 &&

                                        <div className="row">
                                          <div className="form-group text-box-margin">
                                            <div className="col-md-4">
                                              <label htmlFor="spcf1">
                                                {" "}
                                                {data.show.sp1.label !== "" ? data.show.sp1.label.charAt(0).toUpperCase() + data.show.sp1.label.slice(1) : "Specification 1"}{data.show.sp1.req == '1' && '*'}{" "}
                                              </label>
                                            </div>
                                            {auctype != 0 ?
                                              <div className="col-md-8">
                                                {" "}
                                                <input
                                                  placeholder={data.show.sp1.pholder || "Specification 1"}
                                                  className="form-control"
                                                  type="text"
                                                  {...register("spcf1", {})}
                                                />
                                              </div>
                                              :
                                              <div className="col-md-6">
                                                {" "}
                                                <select
                                                  className="form-control"
                                                  id="spcf1"
                                                  type="text"
                                                  {...register("spcf1", {
                                                    required: data.show.sp1.req == 1 ? "This is required" : false

                                                  })}
                                                  onChange={(e) => {
                                                    if (e.target.value === "Other") {
                                                      setOtherBatting(true);
                                                    } else {
                                                      setOtherBatting(false);
                                                    }
                                                    setBatting(e.target.value);
                                                  }}
                                                >
                                                  <option value={""}>--select--</option>
                                                  {sp1opt.map((ele) => (
                                                    <option value={ele}>
                                                      {ele}
                                                    </option>
                                                  ))}
                                                </select>
                                                {errors.spcf1 && (
                                                  <p className="text-error">
                                                    {errors.spcf1.message}
                                                  </p>
                                                )}
                                              </div>}
                                          </div>
                                        </div>
                                      }
                                    </div>
                                    {otherBatting ? (
                                      <div className="col-md-6">
                                        <div className="row form-group text-box-margin">
                                          <div className="col-md-4">
                                            <label htmlFor="spcf2"> Other </label>
                                          </div>
                                          <div className="col-md-8">
                                            <input
                                              placeholder="Other"
                                              className="form-control"
                                              type="text"
                                              {...register("spcf1_other")}
                                              onChange={(e) =>
                                                setBatting(e.target.value)
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </div>

                                <div className="col-md-12 margin-top-14px">
                                  {data != '' && data.show.sp2.show == 1 &&

                                    <div className="row">
                                      <div className="col-md-6">
                                        <div className="row">
                                          <div className="form-group text-box-margin">
                                            <div className="col-md-4">
                                              <label htmlFor="spcf2">
                                                {" "}
                                                {data.show.sp2.label !== "" ? data.show.sp2.label.charAt(0).toUpperCase() + data.show.sp2.label.slice(1) : "Specification 2"}{data.show.sp2.req == '1' && '*'}{" "}
                                              </label>
                                            </div>
                                            {auctype != 0 ?
                                              <div className="col-md-8">
                                                {" "}
                                                <input
                                                  placeholder={data.show.sp2.pholder || "Specification 2"}
                                                  className="form-control"
                                                  type="text"
                                                  {...register("spcf2", {})}
                                                />
                                              </div>
                                              :
                                              <div className="col-md-6">
                                                {" "}
                                                <select
                                                  className="form-control"
                                                  id="spcf2"
                                                  type="text"
                                                  {...register("spcf2", {
                                                    required: data.show.sp2.req == 1 ? "This is required" : false

                                                  })}
                                                  onChange={(e) => {
                                                    if (e.target.value === "Other") {
                                                      setOtherBowling(true);
                                                    } else {
                                                      setOtherBowling(false);
                                                    }
                                                    setBowling(e.target.value);
                                                  }}
                                                >
                                                  <option value={""}>--select--</option>
                                                  {(batting == 'Bowling All Rounder' || batting == 'Bowler') ? sp3opt.map((ele) => (
                                                    <option value={ele}>
                                                      {ele}
                                                    </option>
                                                  )) : sp2opt.map((ele) => (
                                                    <option value={ele}>
                                                      {ele}
                                                    </option>
                                                  ))}
                                                  <option value='Other'>
                                                    Other
                                                  </option>
                                                </select>
                                                {errors.spcf2 && (
                                                  <p className="text-error">
                                                    {errors.spcf2.message}
                                                  </p>
                                                )}
                                              </div>
                                            }
                                          </div>
                                        </div>
                                      </div>
                                      {otherBowling ? (
                                        <div className="col-md-6">
                                          <div className="row form-group text-box-margin">
                                            <div className="col-md-4">
                                              <label htmlFor="spcf2"> Other </label>
                                            </div>
                                            <div className="col-md-8">
                                              <input
                                                placeholder="Other"
                                                className="form-control"
                                                // {...register("spcf2")}
                                                type="text"
                                                {...register("spcf2_other")}
                                                onChange={(e) =>
                                                  setBowling(e.target.value)
                                                }
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  }
                                </div>
                                {data != '' && data.show.sp3.show == 1 &&
                                  <div className="row">
                                    <div className="col-md-6 margin-top-14px">
                                      <div className="form-group text-box-margin">
                                        <div className="col-md-4">
                                          <label htmlFor="spcf1">
                                            {" "}
                                            {data.show.sp3.label !== "" ? data.show.sp3.label.charAt(0).toUpperCase() + data.show.sp3.label.slice(1) : "Specification 3"}{data.show.sp3.req == '1' && '*'}{" "}
                                          </label>
                                        </div>
                                        {auctype != 0 ?
                                          <div className="col-md-8">
                                            {" "}
                                            <input
                                              placeholder={data.show.sp3.pholder || "Specification 3"}
                                              className="form-control"
                                              type="text"
                                              {...register("spcf3", {})}
                                            />
                                          </div>
                                          :
                                          <div className="col-md-6">
                                            {" "}
                                            <select
                                              className="form-control"
                                              id="spcf3"
                                              type="text"
                                              {...register("spcf3", {
                                                required: false,
                                                // required: "required field.",
                                              })}
                                              onChange={(e) => {
                                                if (e.target.value === "Other") {
                                                  setOthersp3(true);
                                                } else {
                                                  setOthersp3(false);
                                                }
                                                setsp3(e.target.value);
                                              }}
                                            >
                                              <option value={""}>--Specification 3--</option>
                                              {(batting == 'Bowling All Rounder' || batting == 'Bowler') ? sp2opt.map((ele) => (
                                                <option value={ele}>
                                                  {ele}
                                                </option>
                                              )) : sp3opt.map((ele) => (
                                                <option value={ele}>
                                                  {ele}
                                                </option>
                                              ))}

                                              <option value='Other'>
                                                Other
                                              </option>
                                            </select>
                                            {errors.spcf2 && (
                                              <p className="text-error">
                                                {errors.spcf2.message}
                                              </p>
                                            )}
                                          </div>
                                        }
                                      </div>
                                    </div>
                                    {othersp3 ? (
                                      <div className="col-md-6">
                                        <div className="row form-group text-box-margin">
                                          <div className="col-md-4">
                                            <label htmlFor="spcf2"> Other </label>
                                          </div>
                                          <div className="col-md-8">
                                            <input
                                              placeholder="Other"
                                              className="form-control"
                                              type="text"
                                              {...register("spcf3_other")}
                                              onChange={(e) =>
                                                setsp3(e.target.value)
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                }
                                {data != '' && data.show.detail.show == 1 &&

                                  <div className="col-md-12">

                                    <div className="form-group text-box-margin">
                                      <label htmlFor="detail">
                                        {" "}
                                        {data.show.detail.label !== "" ? data.show.detail.label.charAt(0).toUpperCase() + data.show.detail.label.slice(1) : "Detail"}{data.show.detail.req == '1' && '*'}{" "}
                                      </label>
                                      <textarea
                                        className="form-control"
                                        placeholder={data.show.detail.pholder || "Detail"}
                                        id="other_details"
                                        {...register("detail", {
                                          required: data.show.detail.req == 1 ? "This is required" : false

                                        })}
                                      ></textarea>
                                    </div>

                                  </div>
                                }
                                {localStorage.getItem('auction_id') == 38524 &&
                                  <div className='qr-container col-md-6'>
                                    <img src={qr1} alt="" />
                                    <p><b>Registration fees : 800/-</b></p>
                                  </div>}
                                <div className="col-md-12">
                                  {localStorage.getItem('auction_id') == 37866 ?
                                    <>
                                      <h4>IMPORTANT NOTES BEFORE YOU REGISTER.</h4>
                                      <p>1. Player Registration Fee is Rs.2500/- .</p>
                                      <p>2. No Refund After Registration.</p>
                                      <p>3. Auction Related Information will be shared On JSCA Information Group Only.</p>
                                      <p>4. Last Date Of Submission - 18 December 2024. </p>
                                      <p>Tournament Dates : 2 March 2025, 9 March 2025, 16 March 2025, 23 March 2025.</p>
                                      <p><b>5. Please make sure you are available for the tournament on the dates mentioned above then register.</b></p>

                                      <p><input type="checkbox" required style={{ 'min-height': '20px', 'margin-right': '10px' }} />I read and agree above points and want to join.</p>
                                    </>
                                    :
                                    <p><input type="checkbox" required style={{ 'min-height': '20px', 'margin-right': '10px' }} />Yes , I want to join.</p>
                                  }





                                  <button
                                    className="button"
                                    onClick={() => (savenew = 0)}
                                    type="submit"
                                    disabled={isSubmitting}
                                    style={{ 
                                      width: "100%",
                                      opacity: isSubmitting ? 0.7 : 1
                                    }}
                                  >
                                    {isSubmitting ? "Joining..." : "Join Auction"}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <NotFound data={""} />
      )}
    </div>
  )
}
